<mat-drawer-container class="settings-drawer h-full top-0 right-0 !absolute" [hasBackdrop]="drawer.opened">
  <mat-drawer #drawer mode="side" (closedStart)="onDrawerClosed()">
      <mat-toolbar class="header-container !pl-0 pr-4 !ml-2">
            <button mat-icon-button class="!flex justify-center" (click)="this.onCloseClick()" i18n-aria-label
                aria-label="close settings drawer" role="button">
                <lib-app-icon id="x_icon" icon="x_icon" [size]="'24x12'" />
            </button>
            <h2 class="drawer-title mat-subtitle-1 flex-auto text" i18n>Settings</h2>
            <img [ngSrc]="profilePicturePath()" width="40" height="40" priority i18n-alt alt="user profile picture"
                (click)="drawer.toggle()" (keypress)="drawer.toggle()" tabindex="0" />
      </mat-toolbar>
      <div class="flex justify-center mb-[10px] mt-[40px]">
          <button i18n (click)="onLogout()" class="mat-body-1 logoutButton">Logout</button>
      </div>
      <div class="absolute bottom-[30px] left-0 w-full flex flex-col items-center justify-center">
          <div class="flex justify-center mt-3.5 pb-6">
              <lib-app-icon [icon]="getIconToShow()" [size]="'46x162'"></lib-app-icon>
          </div>
          <h2 class="flex justify-center mat-headline-6 pb-[36px] text" i18n>DISPOSITION</h2>
          <div i18n class="flex justify-center mat-body-1 versionText">Version 3.2</div>
      </div>
  </mat-drawer>
</mat-drawer-container>